import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { StateHelperService } from '@core/services/state-helper.service';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CustomerStateModel } from '@sales/modules/details/models/customer.model';
import { ChangeCustomerAction } from '@sales/modules/details/states/customer.actions';
import { diegoRoutes } from '@core/enums/orderflow-paths';
import { CustomerSelectors } from '@sales/modules/details/states/customer.selectors';
import { Subscription } from 'rxjs';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-cancel-register-customer-dialog',
  templateUrl: './cancel-register-customer-dialog.component.html',
  styleUrls: ['./cancel-register-customer-dialog.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, IceButtonComponent, MatDialogClose],
})
export class CancelRegisterCustomerDialogComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  router = inject(Router);
  dialogRef = inject<MatDialogRef<CancelRegisterCustomerDialogComponent>>(MatDialogRef);
  private stateHelper = inject(StateHelperService);
  data = inject<{
    navigationPath: string;
  }>(MAT_DIALOG_DATA);

  customer$: Observable<CustomerStateModel> = this.store.select(CustomerSelectors.getState);
  customer: CustomerStateModel;

  subscriptions$: Subscription[] = [];

  ngOnInit() {
    this.subscriptions$.push(
      this.customer$.subscribe({
        next: (value: CustomerStateModel) => {
          this.customer = value;
        },
      })
    );
  }

  confirmReset() {
    const customerType = this.customer.changeCustomer;
    this.stateHelper.resetSaleState();

    if (customerType?.length > 0) {
      this.store.dispatch(new ChangeCustomerAction(''));
    }

    this.router.navigateByUrl(this.data?.navigationPath ?? diegoRoutes.startSale);

    this.dialogRef.close();
  }

  abort() {
    if (this.customer.changeCustomer?.length > 0) {
      this.store.dispatch(new ChangeCustomerAction(''));
    }
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.subscriptions$.forEach(s => s.unsubscribe());
  }
}
